// extracted by mini-css-extract-plugin
export default {"DarkBackground":"DarkBackground_DarkBackground__d9ahq","toggleDarkBackground":"DarkBackground_toggleDarkBackground__yJ76M"};